import './corn&ryespirits/style';
import FormStructure from './corn&ryespirits/form_structure';

export default FormStructure;